module.exports = __webpack_public_path__ + "img/slide1.f105ea39.png";